import { useQuery } from 'react-query';
import { getPlanUnitDetailsAtDate } from 'RestAPIs/cost-centers';
import { toLocalISOString } from 'utils/date';

/**
 * The key holds exactly what is sent to the endpoint. Callers that invalidate
 * this query must build their key here too, so the two cannot drift apart.
 */
export const planUnitDetailsQueryKey = (
  planUnitId?: number,
  referenceDate?: Date | null
): [string, number | undefined, string | null] => [
  'PlanUnitDetails',
  planUnitId,
  referenceDate ? toLocalISOString(referenceDate) : null
];

const useGetPlanUnitDetails = (
  planUnitId?: number,
  referenceDate?: Date | null
) => {
  const queryKey = planUnitDetailsQueryKey(planUnitId, referenceDate);
  // the key already carries the converted date, so reuse it for the request
  const referenceDateISO = queryKey[2];

  const { data, isFetching, isError, refetch } = useQuery(
    queryKey,
    async () => {
      if (!planUnitId || !referenceDateISO) {
        return null;
      }

      const { data } = await getPlanUnitDetailsAtDate({
        planUnitId,
        referenceDate: referenceDateISO
      });
      return data;
    }
  );

  return { data, isFetching, isError, refetch };
};
export default useGetPlanUnitDetails;
